(function ($) {

  /*
   * add Class on scroll
   */
  function scrollTop() {
    var $position = $(document).scrollTop();
    // console.log($position);
    if ($position > 894) {
      $('.scroll-top').fadeIn();
    } else {
      $('.scroll-top').fadeOut();
    }
  }

  $(window).on('scroll', function () {
    scrollTop();
  });

  $(document).ready(function () {
    scrollTop();
    /*
     *  For scroll body
     */
    $('.scroll-top').click(function () {
      $('html, body').animate({'scrollTop': "0"}, 800);
    });

    $('body footer .content-wrapper .third-block').find('a').addClass('btn-default');
  });

})(jQuery);